export interface LoginLayoutChangePasswordState {
    password: string
    passwordConfirmation: string
    error: string
    success: string
    busy: boolean
    showPassword: boolean
}
export const initialLoginLayoutChangePasswordState =
    (): LoginLayoutChangePasswordState => ({
        password: '',
        passwordConfirmation: '',
        error: '',
        success: '',
        busy: false,
        showPassword: false
    })
